import { createContext } from "react";

import { ICheckoutPageContext } from "../interfaces-and-types";

export const CheckoutPageContext = createContext<ICheckoutPageContext>({
  isInitialized: false,

  // checkout locking
  checkoutItemsLocked: false,
  lockCheckoutItems: () => {},

  // hide the payment method switcher
  paymentMethodSwitcherVisible: false,
  showPaymentMethodSwitcher: () => {},
  hidePaymentMethodSwitcher: () => {},

  country: "NG",
  setCountry: () => {},

  // customer details
  customer: {
    email: "",
  },
  setCustomer: () => {},

  // total
  saleCurrency: "",
  setSaleCurrency: () => {},
  saleTotal: 0,
  setSaleTotal: () => {},

  // line items
  line_items: [],
  setLineItems: () => {},
  searchLineItemsText: null,
  setSearchLineItemsText: () => {},
});
